import React, { useEffect, useState } from "react";
import { Download, FileText, RefreshCcw, Search } from "lucide-react";
import { saveAs } from 'file-saver';
import "./ReportDashboard.scss";
import Lottie from 'lottie-react';
import animationData from '../../assets/lottieFiles/files.json';
import { fetchReportData, GetCompanyList, GetFiscalYearList, getReportJSON, GetStoresList } from "../../services/fetchReportData";
import { CustomTable } from "../customTable";
import { Pagination } from "../pagination";
import { toast } from "react-toastify";
import { useSearchParams } from 'react-router-dom';
import { CustomLoader } from "../Loader";
import { Autocomplete } from "../autocomplete/Autocomplete";
import moment from "moment/moment";
const ReportDashboard = () => {
    const [searchParams] = useSearchParams();
    const category_name = searchParams.get('categoryName');
    const [reportData, setReportData] = useState([]);
    const [reportName, setReportName] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [reportJson, setReportJson] = useState([]);
    const [loading, setLoading] = useState(false);
    const [extraPaload, setExtraPayload] = useState({
        company: "",
        fiscalYear: "",
        stores: ""
    })
    const [paginationInfo, setPaginationInfo] = useState({
        limit: 100,
        offset: 0,
        totalRecords: 0,
        currentRecords: 0,
    });
    const [categoryName, setcategoryName] = useState("")
    const [listLoading, setListLoading] = useState(false)
    const [storeList, setStoreList] = useState([])
    const [CompanyData, setCompanyData] = useState([])
    const [fiscalyearData, setFiscalYeardata] = useState([])
    const userToken = localStorage.getItem("user_token");
    console.log(fromDate, "fromDate");


    useEffect(() => {
        const getData = async () => {
            try {
                setListLoading(true);
                const data = await fetchReportData(userToken);

                const dataformating = data?.message?.categories
                    ?.filter(item => item?.count > 0)
                    ?.map(item => ({
                        title: item?.category,
                        count: item?.count,
                        content: item?.reports,
                    }));

                setReportData({
                    data: dataformating,
                    overall_count: data?.message?.overall_count,
                });


                setListLoading(false);
            } catch (error) {
                setListLoading(false);
                console.error('Error fetching report data:', error);
            }
        };
        getData();
        getStoreData()
        getCompanyData()
        getFiscalYearData()
    }, [userToken]);


    const getStoreData = async () => {
        try {
            let data = await GetStoresList()
            setStoreList(data?.message?.warehouses)
        } catch (error) {
            console.log(error);

        }
    }

    const fetchTableData = async () => {
        try {
            setLoading(true);
            setReportJson([]);
            let filters = { from_date: fromDate, to_date: toDate, warehouse: extraPaload?.stores }
            if (["Item-wise Sales History", "Item-wise Purchase History", "General Ledger", "Bank Reconciliation Statement", "Trial Balance", "Profit and Loss Statement","Balance Sheet","Cash Flow","Bank Reconciliation Statement"].includes(reportName)) {
                filters.company = extraPaload?.company;
                filters.item_group = "products";
                filters.fiscal_year = extraPaload?.fiscalYear
            }

            if (reportName === "Bank Reconciliation Statement") {
                filters.account = "Debtors - ELPL";
                filters.report_date=fromDate

            }
            if (reportName === "Profit and Loss Statement"||reportName === "Cash Flow" || reportName === "Balance Sheet") {

                delete filters.from_date
                delete filters.to_date
                delete filters.fiscal_year

                filters.filter_based_on = extraPaload.fiscalYear
                filters.period_start_date = fromDate
                filters.period_end_date = toDate
                filters.periodicity = "Yearly"
                filters.selected_view = "Report"
                filters.accumulated_values = 1
                filters.include_default_book_entries = 1
            }

            if (reportName === "Trial Balance") {
                filters = { ...filters, "with_period_closing_entry_for_opening": 1, "with_period_closing_entry_for_current_period": 1, "include_default_book_entries": 1, "show_net_values": 1 }
            }


            let data = await getReportJSON(
                reportName,
                filters,
                paginationInfo
            );

            setPaginationInfo({
                limit: data.limit_info?.limit || 1000,
                offset: data.limit_info?.offset || 0,
                totalRecords: data.limit_info?.total_records || 0,
                currentRecords: data.limit_info?.current_records || 0
            });

            setReportJson(data?.message);
            console.log(data, "tableData");
        } catch (error) {
            console.error("Failed to fetch table data:", error);
            toast.error("Failed to load report data"); // optional toast message
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (reportName) {
            fetchTableData()
        }
    }, [reportName, paginationInfo.offset])


    const exportToCSV = (dataToExport, fileName) => {
        try {
            let recentlyUsed = localStorage.getItem('recentReport') || '[]';
            let temp = JSON.parse(recentlyUsed);

            const csvContent = convertToCSV(dataToExport);
            if (!csvContent) {
                toast.warning('No data to export');
                return;
            }

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, `${fileName}_${new Date().toISOString().split('T')[0]}.csv`);

            const now = new Date().toISOString();

            const existingIndex = temp.findIndex(item => item?.fileName === fileName);

            if (existingIndex !== -1) {
                temp[existingIndex].time = now;
            } else {
                temp.unshift({ categoryName, time: now, fileName });
            }

            temp = temp.slice(0, 4);
            localStorage.setItem('recentReport', JSON.stringify(temp));
            toast.success('Download started');
        } catch (error) {
            console.error('Error exporting to CSV:', error);
            toast.error('Failed to generate CSV file');
        }
    }

    const convertToCSV = (dataToExport) => {

        if (!dataToExport || dataToExport.length === 0) return '';

        const headers = Object.keys(dataToExport[0]);
        const csvRows = [];
        csvRows.push(headers.join(','));

        dataToExport.forEach(row => {
            const values = headers.map(header => {
                const value = row[header];
                const escaped = ('' + (value !== null && value !== undefined ? value : ''))
                    .replace(/"/g, '""');
                return `"${escaped}"`;
            });
            csvRows.push(values.join(','));
        });

        return csvRows.join('\n');


    };
    console.log(storeList, "storeList");

    const getCompanyData = async () => {
        try {
            let getData = await GetCompanyList()
            // console.log(getData?.message?.companies
            //     ,"GetComapnyList");
            setCompanyData(getData?.message?.companies)
        } catch (error) {
            console.log(error);

        }
    }
    const getFiscalYearData = async () => {
        try {
            let getData = await GetFiscalYearList()
            // console.log(getData?.message,"GetComapnyList");
            setFiscalYeardata(getData?.message?.fiscal_years)

        } catch (error) {
            console.log(error);

        }
    }

    return (
        <div className="report-dashboard">
            {/* Sidebar */}
            <aside className="sidebar" style={{ width: "400px" }}>
                {/* <div className="search-bar">
                    <input type="text" placeholder="Search reports..." />
                </div> */}

                <div className="report-section">
                    <div className="scroll-area">
                        <div className="section">
                            <div className="section-title">All Reports in {category_name}</div>
                            {
                                listLoading ? <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '50vh',
                                    backgroundColor: '#f0f0f0',
                                    flexDirection: 'column'
                                }}>

                                    <CustomLoader />
                                </div> :


                                    reportData?.data?.length > 0 ?
                                        <div>
                                            {reportData?.data
                                                ?.find((item) => item?.title === category_name)
                                                ?.content?.map((report, index) => (
                                                    <div
                                                        key={index}
                                                        className="accordion-inner"
                                                        onClick={() => {
                                                            setcategoryName(category_name)
                                                            setReportName(report)
                                                            if (["Item-wise Sales History",
                                                                "Item-wise Purchase History",
                                                                "General Ledger",
                                                                "Balance Sheet",
                                                                "Bank Reconciliation Statement", "Trial Balance", "Profit and Loss Statement","Cash Flow"].includes(report)) {
                                                                let date = moment().format('YYYY-MM-DD')
                                                                setFromDate(date)
                                                                setToDate(date)
                                                                setExtraPayload((prev => ({
                                                                    ...prev,
                                                                    company: "Enovate Lifestyles Private Limited",
                                                                    fiscalYear: "FY 24-25"
                                                                })))
                                                            }
                                                        }}
                                                    >
                                                        <FileText className="icon" /> {/* Optional: add styling */}
                                                        {report}
                                                    </div>
                                                ))}
                                        </div>

                                        : <div>
                                            <p style={{ height: "700px", backgroundColor: "#f0f0f0", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
                                                There is no data available
                                            </p>
                                        </div>}
                        </div>
                    </div>
                </div>
            </aside>

            {/* Main content */}


            {
                reportName === "" ? <div className="main-content" style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#f5f6fa"
                }} >
                    <Lottie
                        animationData={animationData}
                        loop={true}
                        style={{ width: "300px", height: "300px" }}
                    />
                    <h2 style={{ color: "#f26c0d", fontSize: "20px", marginTop: "20px" }}>Select a report to view</h2>
                </div> :

                    <main className="main-content">
                        <header className="page-header">
                            <h2>{reportName.replace("Report", "").trim()} Reports</h2>
                        </header>


                        {reportName !== "All Stores" && <div className="filter-grid">
                            <div className="form-group">
                                <label style={{
                                    marginBottom: " 10px",
                                }}  >
                                    {
                                        reportName === "Bank Reconciliation Statement" ?"Report Date":"From Date"
                                    }
                                    </label>
                                <div className="input-icon" style={{
                                    marginTop: "10px",
                                }} >
                                    <input type="date"
                                        value={fromDate}
                                        onFocus={(e) => e.target.showPicker?.()} style={{ cursor: "pointer" }}
                                        onChange={(e) => {
                                            setFromDate(e.target.value)
                                            console.log(e.target.value, " e.target.value;");

                                        }}
                                    />
                                </div>
                            </div>

                           {reportName !== "Bank Reconciliation Statement" &&<div className="form-group">
                                <label style={{
                                    marginBottom: " 10px",
                                }} >To Date</label>
                                <div className="input-icon" style={{
                                    marginTop: "10px",
                                }}>
                                    <input type="date"
                                        value={toDate}
                                        onFocus={(e) => e.target.showPicker?.()} style={{ cursor: "pointer" }}
                                        onChange={(e) => {
                                            setToDate(e.target.value)
                                            console.log(e.target.value, " e.target.value;");
                                        }}
                                    />
                                </div>


                            </div>}
                        </div>}
                        <div className="" style={{
                            display: "flex",
                            gap: "10px"

                        }}>
                            {
                                (reportName === "All Stores" || reportName === "Prev Day Stock Report") &&
                                <div className="form-group" style={{
                                    marginTop: "10px",
                                }} >
                                    <label style={{
                                        marginBottom: " 10px",
                                    }} >Stores</label>
                                    <div className="input-icon" style={{
                                        marginTop: "10px",
                                    }} >
                                        <Autocomplete
                                            suggestions={storeList}
                                            onSelect={(e) => {
                                                // setStoreName(e)
                                                setExtraPayload((prev) => ({
                                                    ...prev,
                                                    stores: e  // replace `newValue` with the actual value you want to set
                                                }));
                                            }}
                                            value={extraPaload?.stores}
                                        />
                                    </div>
                                </div>}

                            {
                                ["Item-wise Sales History", "Item-wise Purchase History", "General Ledger", "Bank Reconciliation Statement", "Trial Balance", "Profit and Loss Statement","Balance Sheet","Cash Flow"].includes(reportName) &&
                                <div className="form-group" style={{
                                    marginTop: "10px",
                                }} >
                                    <label style={{
                                        marginBottom: " 10px",
                                    }} >Company</label>
                                    <div className="input-icon" style={{
                                        marginTop: "10px",
                                    }} >
                                        <Autocomplete
                                            suggestions={CompanyData}
                                            onSelect={(e) => {
                                                // setStoreName(e)
                                                setExtraPayload((prev) => ({
                                                    ...prev,
                                                    company: e
                                                }));
                                            }}
                                            value={extraPaload?.company}
                                        />
                                    </div>
                                </div>}
                            {
                                (reportName === "Trial Balance" || reportName ==="Item-wise Purchase History") &&
                                <div className="form-group" style={{
                                    marginTop: "10px",
                                }} >
                                    <label style={{
                                        marginBottom: " 10px",
                                    }} >Fiscal Year</label>
                                    <div className="input-icon" style={{
                                        marginTop: "10px",
                                    }} >
                                        <Autocomplete
                                            suggestions={fiscalyearData}
                                            onSelect={(e) => {
                                                setExtraPayload((prev) => ({
                                                    ...prev,
                                                    fiscalYear: e  // replace `newValue` with the actual value you want to set
                                                }));
                                            }}
                                            value={extraPaload?.fiscalYear}
                                        />
                                    </div>
                                </div>}
                        </div>


                        <div style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            marginBottom: "20px",
                            gap: "10px",
                        }}>
                            <button
                                onClick={() => {
                                    exportToCSV(reportJson, reportName)
                                }}
                                className="reports-button" disabled={loading || reportJson?.length === 0}  >
                                <Download size={18} /> Export to Csv
                            </button>

                            <button
                                onClick={() => {
                                    fetchTableData()
                                }}
                                className="reports-button"
                                disabled={
                                    reportName === "All Stores"
                                        ? extraPaload?.stores === "" || extraPaload?.stores === null
                                        : fromDate === null ||
                                        toDate === null ||
                                        fromDate === "" ||
                                        toDate === ""}  >

                                <Search size={18} /> Search
                            </button>
                            <button
                                onClick={() => {
                                    // fetchTableData()

                                    setFromDate("")
                                    setToDate("")
                                    // setStoreName("")
                                    setExtraPayload({
                                        company: "",
                                        stores: "",
                                        fiscalYear: ""
                                    })
                                }}
                                className="reports-button"   >

                                <RefreshCcw size={18} /> Refresh
                            </button>
                        </div>
                        <div className="">
                            <p>Total Records : {paginationInfo?.totalRecords}</p>
                        </div>
                        <div className="table-container">
                            {loading ? (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '50vh',
                                    // backgroundColor: '#f0f0f0',
                                    flexDirection: 'column'
                                }}>

                                    <CustomLoader />
                                </div>
                            ) : Array.isArray(reportJson) && reportJson.length > 0 ? (

                                <CustomTable tableData={reportJson} loading={loading} />
                            ) : (
                                <div style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", }}>No data available</div>
                            )}
                        </div>
                        <div className="">

                            <Pagination
                                limit={paginationInfo?.limit}
                                offset={paginationInfo?.offset}
                                totalRecords={paginationInfo?.totalRecords}
                                onPageChange={(offset) => {
                                    setPaginationInfo((prev) => ({
                                        ...prev,
                                        offset: offset,
                                    }));
                                }}
                            />

                        </div>

                    </main>}
        </div>
    );
};

export default ReportDashboard;
